import React, { useRef, useState } from "react";
import styles from './MultiSelectDropdown.module.scss';
import PropTypes from "prop-types";
import useClickOutside from "../../hooks/useClickOutside";
import Checkbox from "../checkbox/Checkbox";
import {ReactComponent as XCircleIcon} from './XCircle.svg';
import {ReactComponent as ChevronUp} from './ChevronUp.svg';

const MultiSelectDropdown = ({
  label,
  options,
  selected = [],
  onChange,
  error,
  disabled = false
}) => {
  const [showList, setShowList] = useState(false);
  const containerRef = useRef(null); 

  useClickOutside(containerRef, () => setShowList(false));

  const handleToggle = (value) => {
    const index = selected.indexOf(value);
    let updated;
    if (index === -1) {
      updated = [...selected, value];
    } else {
      updated = selected.filter(i => i !== value);
    }
    onChange(updated);
  };

  return (
    <div className={styles.container} ref={containerRef}>
      {label && (
        <label className={styles.label}>{label}</label>
      )}
      <div
        className={`
          ${styles.input} 
          ${error ? styles.errorInput : ''}
          ${disabled ? styles.disabled : ''}
        `}
        onClick={() => {
          if(!disabled) {
            setShowList(!showList)
          }
        }}
      >
        <div className={styles.selectedList}>
          {options.map((item, index) => {
            return selected.includes(item.value) ? 
              <span className={styles.tag} key={`tag-${index}`}>
                {item.label}
                {!disabled && <XCircleIcon onClick={(e) => {
                  e.stopPropagation();
                  handleToggle(item.value);
                }}/>}
              </span> : 
              '';
          })}
        </div>
        {!disabled && <span className={`${styles.arrow} ${showList ? styles.upArrow : styles.downArrow}`}><ChevronUp /></span>}
      </div>
      {showList && options.length > 0 && <ul className={styles.list}>
        {options.map((item)=> {
          return (
            <li
              onClick={() => handleToggle(item.value)}
              key={item.value}
            >
              <Checkbox
                checked={selected.includes(item.value)}
                onChange={() => handleToggle(item.value)}
              />
              {item.label}
            </li>
          );
        })}
      </ul>}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

MultiSelectDropdown.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool
}

export default MultiSelectDropdown;